import { jwtDecode } from 'jwt-decode';

import type { IUserTokenPayload } from './user.types';
import LocalStorageService, {
  ELocalStorageKeys,
} from 'services/localStorage/localStorage.service';

export const removeUserSession = (): void => {
  LocalStorageService.remove(ELocalStorageKeys.heroUserToken);
  LocalStorageService.remove(ELocalStorageKeys.heroUserRefreshToken);
};

export const storeToken = (token?: string): void => {
  if (token) {
    LocalStorageService.set(ELocalStorageKeys.heroUserToken, token);
  }
};

export const storeRefreshToken = (token?: string): void => {
  if (token) {
    LocalStorageService.set(ELocalStorageKeys.heroUserRefreshToken, token);
  }
};

export const getToken = (): string | null => {
  return LocalStorageService.get(ELocalStorageKeys.heroUserToken);
};

export const getRefreshToken = (): string | null => {
  return LocalStorageService.get(ELocalStorageKeys.heroUserRefreshToken);
};

export const removeToken = (): void => {
  LocalStorageService.remove(ELocalStorageKeys.heroUserToken);
};

export const removeRefreshToken = (): void => {
  LocalStorageService.remove(ELocalStorageKeys.heroUserRefreshToken);
};

export const getPayloadFromToken = (
  token: string | null
): IUserTokenPayload => {
  if (!token) {
    // TODO: change it later
    throw new Error('Token is not available');
  }

  const { email, roles } = jwtDecode(token) as IUserTokenPayload;
  return { email, roles };
};

export const getTokenPayload = (): IUserTokenPayload | null => {
  const token = LocalStorageService.get(ELocalStorageKeys.heroUserToken);
  if (!token) return null;
  return getPayloadFromToken(token);
};

/**
 * calls back when another tab of the origin ends the session by removing the
 * token. The storage event only fires in the other tabs, with key null when
 * the whole storage was cleared. A replaced token (refresh) is ignored
 */
export const onSessionEndedInOtherTab = (
  callback: () => void
): (() => void) => {
  const handleStorage = (event: StorageEvent): void => {
    if (event.key !== null && event.key !== ELocalStorageKeys.heroUserToken) {
      return;
    }
    if (getToken()) {
      return;
    }
    callback();
  };

  window.addEventListener('storage', handleStorage);
  return () => window.removeEventListener('storage', handleStorage);
};
